<template>
    <el-dialog
        :before-close="cancel"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        center
        top="3%"
        width="70%">
        <div class="flex flex-direction">
            <div class="menus flex align-center justify-between">
                <div v-for="(item,index) in menus" :key="index" class="menu" :class="{active:curTab === item.value,disabled:aid === 0 && index !== 0 }"
                @click="tabChange(item)">
                    {{item.label}}
                </div>
            </div>
            <div class="margin-top-sm" style="height: 70vh;overflow: auto">
                <meeting-issue v-show="curTab === 0" :type="type" :aid="aid" @watchNext="watchNext"></meeting-issue>
                <meeting-procedure v-if="curTab === 1" :type="type" :aid="aid" @watchNext="watchNext"></meeting-procedure>
                <meeting-workable v-show="curTab === 2" :type="type" :aid="aid" @watchNext="watchNext"></meeting-workable>
            </div>
        </div>
    </el-dialog>
</template>

<script>


import {party_council_meeting_menu, party_member_meeting_menu} from "@/utils/const";
import MeetingIssue from "@/views/web/manager/page/meeting/components/MeetingIssue";
import MeetingProcedure from "@/views/web/manager/page/meeting/components/MeetingProcedure";
import MeetingWorkable from "@/views/web/manager/page/meeting/components/MeetingWorkable";
import {getMeetingDetail} from "@/api";

export default {
    name: "AddMemberMeetingDialog",
    components: {MeetingWorkable, MeetingProcedure, MeetingIssue},
    data() {
        return {
            menus: this.type === 1 ? party_member_meeting_menu : party_council_meeting_menu,
            curTab:0,
            status:0
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        type: {//1党员大会 2 委员会
            type: Number,
            default: 1
        },
        aid: {
            type: Number,
            default: 0
        },
        index: {
            type: Number,
            default: 0
        },
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        this.curTab = this.index
        if (this.aid) {
            this.init();
        } else {
            this.status = 0
        }
    },
    methods: {
        async init() {
            let _data = await getMeetingDetail(this.aid)
            this.status = _data.data.status
        },
        tabChange(item) {
           if (this.aid && (this.status - item.value > -1)) this.curTab = item.value
        },
        watchNext(data,next) {
            if (next)this.curTab ++
            if (data) this.$emit('watchState', data)
        },
        cancel() {
            this.$emit('watchState', false)
        },
    },
    filters: {},
    watch: {
        index() {
            this.curTab = this.index
        },
        aid() {
            if (this.aid) {
                this.init();
            } else {
                this.status = 0
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.menus {
    .menu {
        width: 416px;
        height: 69px;
        line-height: 69px;
        text-align: center;
        background-color: #e7e7e7;
        font-size: 26px;
        font-weight: bold;
        color: #aeaeae;
        cursor: pointer;
        position: relative;
        &:after {
            position: absolute;
            left: 0px;
            border-top: 8px solid transparent;
            border-left: 8px solid #FFFFFF;
            border-bottom: 8px solid transparent;
            top: 50%;
            transform: translateY(-50%);
            content: '';
        }
        &:before {
            position: absolute;
            right: -8px;
            border-top: 8px solid transparent;
            border-left: 8px solid #e7e7e7;
            border-bottom: 8px solid transparent;
            top: 50%;
            transform: translateY(-50%);
            content: '';
        }
        &:first-child {
            &:after {
                display: none;
            }
        }
        &:last-child {
            &:before {
                display: none;
            }
        }
        &.active {
            background-image: linear-gradient(-21deg,
                #920606 0%,
                #ab1111 57%,
                #c41c1c 100%),
            linear-gradient(
                    #a01212,
                    #a01212);
            background-blend-mode: normal,
            normal;
            color: #ffffff;
            &:before {
                position: absolute;
                right: -8px;
                border-top: 8px solid transparent;
                border-left: 8px solid #960707;
                border-bottom: 8px solid transparent;
                top: 50%;
                transform: translateY(-50%);
                content: '';
            }
        }
        &.disabled {
            cursor: not-allowed;
        }
    }
}
</style>